import type { Session } from "sip.js";
import { sipFailureEvidence } from "./call-failure";

// SIP.js delegates replace its default BYE acceptance. Preserve that exact
// behavior when there was no delegate; observation must not keep a call alive.
export function observeSessionBye(session: Session, record: (type: string, detail: Record<string, any>) => void) {
  const delegate = session.delegate;
  const observe = (type: string, detail = {}) => {
    try { record(type, detail); } catch { /* Observation cannot interrupt SIP. */ }
  };
  session.delegate = {
    ...delegate,
    onBye: bye => {
      const { failureSource, ...reasonCodes } = sipFailureEvidence({ message: bye.request });
      observe("remote_bye_received", reasonCodes);
      if (delegate?.onBye) delegate.onBye(bye);
      else void bye.accept().catch(() => observe("remote_bye_accept_failed"));
    }
  };
}
